import { mutations } from 'RestAPIs/rapini';
import { useQueryClient } from 'react-query';
import type { AxiosError } from 'axios';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

/**
 * Paying out and rejecting requests. Both refresh the overview afterwards: the status and the
 * processed mark come from the server, and paying out also creates a nominal duty there.
 */
export const useHoursPayOutProcessing = () => {
  'use memo';

  const queryClient = useQueryClient();

  const options = {
    onSuccess: () => {
      showSuccessSnackbar();
      // returned, not fired and forgotten: react-query keeps the mutation loading until the promise
      // settles, so isProcessing (and with it the overlay) covers the refetch too. Without the
      // return, the overlay clears while the refetch is still in flight and the grid shows the
      // pre-approve rows - including their stale "actueel saldo" - for that moment.
      // partial key: every date range and filter variant of the overview is stale after processing
      return queryClient.invalidateQueries([
        'findHoursPayOutRequestsByOrganizationalUnits'
      ]);
    },
    onError: (error: unknown) =>
      showErrorSnackbar((error as AxiosError)?.message)
  };

  const payOutMutation = mutations.useApproveHoursPayOutRequests(options);
  const rejectMutation = mutations.useRejectHoursPayOutRequests(options);

  return {
    payOut: (hoursPayOutRequestIds: string[]) =>
      payOutMutation.mutate({ hoursPayOutRequestIds }),
    reject: (hoursPayOutRequestIds: string[], statusNote: string) =>
      rejectMutation.mutate({ hoursPayOutRequestIds, statusNote }),
    isProcessing: payOutMutation.isLoading || rejectMutation.isLoading
  };
};
